import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6397bd42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "question" }
const _hoisted_2 = { class: "question-container" }
const _hoisted_3 = { class: "question-number" }
const _hoisted_4 = { class: "question-question" }
const _hoisted_5 = { class: "question-alternatives" }
const _hoisted_6 = { class: "question-button" }
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alternative = _resolveComponent("Alternative")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, "QUESTION " + _toDisplayString(_ctx.question.id) + " OF " + _toDisplayString(_ctx.total), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.question.question), 1),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.question.alternatives, (alternative, index) => {
          return (_openBlock(), _createBlock(_component_Alternative, {
            key: index,
            alternative: alternative
          }, null, 8, ["alternative"]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.nextQuestion && _ctx.nextQuestion(...args))),
        disabled: _ctx.disableNext
      }, "Next", 8, _hoisted_7)
    ])
  ]))
}